<script setup>
import "@/styles/css/brokerage-calculator.scss";
import "@/styles/css/seo-calculators.scss";
import "@/assets/js/brokerage-calculator";
import { ref } from "vue";
const view = ref(false);
</script>
<template>
  <div class="page-container">
    <section class="calculator-container">
      <!-- breadcrumb template -->
      <section class="breadcrumbs-sec">
        <div class="container breadcrumbs-ol">
          <div class="stocks-indices-breadcrumbs_wrap">
            <ol class="stocks-indices-breadcrumbs">
              <li>
                <a href="/">
                  <span>Trading </span>
                </a>
              </li>
              <li>
                <a>
                  <span>Calculators </span>
                </a>
              </li>
              <li>
                <span>Brokerage Calculator </span>
              </li>
            </ol>
          </div>
        </div>
      </section>
      <!-- end breadcrumb template -->
      <section class="brokerage-calculator-banner">
        <div class="heading">
          <h1>Brokerage Calculator</h1>
          <p>
            Use the brokerage calculator to calculate exactly how much you will
            pay in brokerage and your breakeven.
          </p>
        </div>
      </section>

      <section
        style="padding-bottom: 135px"
        class="brokerage-calculator-table-section"
        ng-app="upstoxSearchModule"
      >
        <div class="container">
          <div
            class="calculator-table-form-view"
            ng-controller="widgetController"
          >
            <form
              method="get"
              class="calculator-form brokerage-calculator-form"
            >
              <div class="form-container">
                <div style="display: none" class="bk-statelist-wrapper">
                  <div class="bk-statelist-container">
                    <div class="bk-statelist">
                      <div class="bk-statelist-txt">
                        Calculating tax rates applicable in
                      </div>
                      <select class="chosen-select" name="bState" id="bState">
                        <option value="DL">Delhi</option>
                        <option value="GJ">Gujarat</option>
                        <option value="MH" selected="">Maharashtra</option>
                        <option value="RJ">Rajasthan</option>
                        <option value="TN">Tamil Nadu</option>
                        <option value="KT">Karnataka</option>
                        <option value="WB">West Bengal</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="bk-cal-box-wrap" id="bkCalBoxWrap">
                  <div
                    class="bk-cal-box wow slideInUp col-sm-12 col-md-8 col-md-offset-2"
                    data-wow-duration="1s"
                    dataid="bkCalBox_-1"
                    style="
                      visibility: visible;
                      animation-duration: 1s;
                      animation-name: slideInUp;
                    "
                  >
                    <div class="">
                      <div class="input-group-radio">
                        <input
                          id="intraday_-1"
                          dataid="intraday_-1"
                          type="radio"
                          name="radio-group"
                          value="Intraday"
                          checked=""
                        />
                        <label for="intraday_-1" onclick="changeTIF(true, this)"
                          >Intraday</label
                        >

                        <input
                          id="delivery_-1"
                          dataid="delivery_-1"
                          type="radio"
                          name="radio-group"
                          value="Delivery"
                        />
                        <label
                          for="delivery_-1"
                          onclick="changeTIF(false, this)"
                          >Delivery</label
                        >
                      </div>
                      <i
                        class="pull-right box-close"
                        dataid="box-close_-1"
                        onclick="javascript:removeBox('bkCalBoxWrap', this)"
                        style="display: none"
                        >×</i
                      >
                    </div>

                    <div class="upstoxSearchModule" dataid="searchbox_-1">
                      <div class="search-container search-container-bkg-calc">
                        <input
                          name="search"
                          id="brokerage-scrip-search"
                          placeholder="Enter at least 3 characters of symbol or name"
                          data-container="-bkg-calc"
                          type="text"
                        />

                        <div
                          class="autocomplete-suggestions"
                          style="
                            top: 42px;
                            left: 0px;
                            width: 636px;
                            border: 1px solid rgb(204, 204, 204);
                          "
                        >
                          <div class="category-tabs">
                            <button
                              data-key="ALL"
                              type="button"
                              class="search-panel-tab active"
                            >
                              ALL</button
                            ><button
                              data-key="FO"
                              type="button"
                              class="search-panel-tab"
                            >
                              F&amp;O</button
                            ><button
                              data-key="CURR"
                              type="button"
                              class="search-panel-tab"
                            >
                              CURRENCY</button
                            ><button
                              data-key="COMM"
                              type="button"
                              class="search-panel-tab"
                            >
                              MCX
                            </button>
                          </div>
                          <div class="search-results"></div>
                        </div>
                      </div>
                    </div>

                    <div class="form-input-row row text-left">
                      <div class="input-group input-group-text col-md-4">
                        <div>Quantity</div>
                        <input
                          type="text"
                          dataid="qty_-1"
                          onblur="extractNumber(this);"
                          onkeypress="return blockNonNumbers(this, event, false, false);"
                          size="8"
                          maxlength="5"
                          value="1"
                        />
                        <div
                          dataid="lotSizeHelper_-1"
                          class="lot-size-helper"
                          style="display: none"
                        >
                          Lot Size: 250
                        </div>
                      </div>

                      <div class="input-group input-group-text col-md-4">
                        <div>Buy Price</div>
                        <input
                          type="text"
                          dataid="buyPrice_-1"
                          maxlength="8"
                          onblur="extractNumber(this);"
                          onkeypress="return blockNonNumbers(this, event, true, false);"
                        />
                      </div>

                      <div class="input-group input-group-text col-md-4">
                        <div>Sell Price</div>
                        <input
                          type="text"
                          dataid="sellPrice_-1"
                          maxlength="8"
                          onblur="extractNumber(this);"
                          onkeypress="return blockNonNumbers(this, event, true, false);"
                        />
                      </div>
                    </div>

                    <div class="brokerage-charges-finals">
                      <div class="brokerage-charges-row">
                        <div class="col-md-3 col-sm-3 col-xs-6 expandcharges">
                          <div>Brokerage</div>
                          <span dataid="lblBrokerage_-1">₹&nbsp;0.00</span>
                        </div>
                        <div class="col-md-3 col-sm-3 col-xs-6 expandcharges">
                          <div>Other Charges</div>
                          <span dataid="lbltaxes_-1">₹&nbsp;0.00</span>
                        </div>
                        <div class="col-md-3 col-sm-3 col-xs-6 expandcharges">
                          <div>Breakeven</div>
                          <span dataid="breakeven_-1">₹&nbsp;0.00</span>
                        </div>
                        <div class="col-md-3 col-sm-3 col-xs-6 expandcharges">
                          <div>Net PnL</div>
                          <span dataid="pnl_-1" class="lblTotalNetPnl"
                            >₹&nbsp;0.00</span
                          >
                        </div>
                        <div class="clearfix"></div>
                        <div class="col-md-12">
                          <hr class="hrline-cnote" />
                        </div>
                      </div>

                      <div
                        class="brokerage-summary-row collapse"
                        dataid="showChargesCollapse"
                      >
                        <div class="brokerage-summary">
                          <div class="col-md-6 brokerage-summary-col1">
                            <p>
                              Brokerage<span
                                dataid="lblBrokerage_-1"
                                class="lblBkg"
                                >₹&nbsp;0.00</span
                              >
                            </p>
                            <p>
                              STT/CTT
                              <span class="" dataid="lblSTT_-1"
                                >₹&nbsp;0.00</span
                              >
                            </p>
                            <p>
                              Transaction Charges<span
                                class=""
                                dataid="lblTurnoverCharges_-1"
                                >₹&nbsp;0.00</span
                              >
                            </p>
                            <p style="display: none">
                              Clearing Charges<span
                                class=""
                                dataid="lblClearingCharges_-1"
                                >₹&nbsp;0.00</span
                              >
                            </p>
                            <p>
                              DP Charges<span class="" dataid="dpCharges_-1"
                                >₹&nbsp;0.00</span
                              >
                            </p>
                            <p>
                              State Stamp Duty<span dataid="lblStampDuty_-1"
                                >₹&nbsp;0.00</span
                              >
                            </p>
                            <p>
                              SEBI Turnover Fees<span
                                dataid="lblSEBITurnover_-1"
                                >₹&nbsp;0.00</span
                              >
                            </p>
                            <p>
                              GST<span class="" dataid="lblServiceTax_-1"
                                >₹&nbsp;0.00</span
                              >
                            </p>
                            <p class="summarytotal">
                              TOTAL TAXES AND CHARGES<span
                                class="lblTotalTransactionCharges"
                                dataid="lblTotalTransactionCharges_-1"
                                >₹&nbsp;0.00</span
                              >
                            </p>
                          </div>
                          <div class="col-md-6 brokerage-summary-col2">
                            <p>
                              Net Buy Value
                              <span dataid="lblNetBuyValue_-1"
                                >₹&nbsp;0.00</span
                              >
                            </p>
                            <p>
                              Net Sell Value
                              <span dataid="lblNetSellValue_-1"
                                >₹&nbsp;0.00</span
                              >
                            </p>
                            <p>
                              Points to breakeven
                              <span dataid="breakeven_-1" class="totalval"
                                >₹&nbsp;0.00</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="showcharges-section">
                        <button
                          class="collapsed"
                          dataid="showcharges"
                          type="button"
                        >
                          <i dataid="dropdown_icon" class="showicon"></i>
                          <div dataid="">SHOW CHARGES BREAKUP</div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="text-center col-md-12 additembtn">
                            <button class="button-add addotherItem" id="addItemNew" type="button" ng-click="addSearch()">
                               + Add Another Order
                            </button>
                        </div> -->
            </form>
          </div>
        </div>
      </section>
    </section>

    <!-- Calculator Info Section -->
    <!-- Calculator FAQ Section -->
    <div class="section-panel calculator-info">
      <section
        class="container calculator_help_section"
        id="calculator_help_section"
      >
        <h2 class="fs-28 bold help_here">Frequently Asked Questions</h2>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#calculator_help_section"
                    href="#collapse1"
                  >
                    <span class="expand_icon dashicons-plus"></span>
                    <span> What is a brokerage calculator?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse1" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    A brokerage calculator is an online tool aimed to help the
                    traders/clients know the exact charges that they might incur
                    when conducting a trade.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#calculator_help_section"
                    href="#collapse2"
                  >
                    <span class="expand_icon dashicons-plus"></span>
                    <span>What are DP Charges?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse2" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    DP charges or Depositary Participant Charges are levied by
                    the Central Depository Services (India) Limited (CDSL) and a
                    broker when a trader sells a share from their Demat Account.
                  </p>
                  <p>
                    Total DP Charges when you place a sell Equity Delivery order
                    – ₹20.0 + GST
                  </p>
                  <p>
                    Breakup of the DP Charges:<br />
                    For Male: ₹3.5 (CDSL) + ₹16.5 (Upstox charges)<br />
                    For Female: ₹3.25 (CDSL) + ₹16.75 (Upstox charges)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#calculator_help_section"
                    href="#collapse3"
                  >
                    <span class="expand_icon dashicons-plus"></span>
                    <span>How is brokerage calculated?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse3" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    You will be charged a brokerage of up to ₹20 per order or
                    the SEBI prescribed limit whichever is lower for equity
                    delivery orders.
                  </p>
                  <p>
                    For equity intraday orders, you will be charged a brokerage
                    of ₹20 per order or 0.1% (whichever is lower) for both buy
                    and sell orders. For all other charges, you can refer to our
                    pricing page –&nbsp;<a href="/brokerage-charges/"
                      >Brokerage Charges</a
                    >. We do not charge any commission/brokerage on Mutual Funds
                    and IPOs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#calculator_help_section"
                    href="#collapse4"
                  >
                    <span class="expand_icon dashicons-plus"></span>
                    <span> How is intraday brokerage calculated?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse4" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    For buying and selling stocks on the same day, known as
                    equity intraday order, you will be charged brokerage of
                    <a href="/brokerage-charges/"
                      >₹20 per order or 0.1% (whichever is lower)</a
                    >
                    for both buy and sell orders.
                  </p>
                  <p>
                    For equity/commodity/currency futures and options brokerage,
                    you can refer to our brokerage charges list –<a
                      href="/brokerage-charges/"
                    >
                      Chargeslist</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#calculator_help_section"
                    href="#collapse5"
                  >
                    <span class="expand_icon dashicons-plus"></span>
                    <span>What are STT charges?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse5" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    For equity delivery,
                    <a href="/brokerage-charges/">STT</a> is 0.1% on both buying
                    &amp; selling of shares. For equity intraday, STT is 0.1% on
                    both buying &amp; selling.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#calculator_help_section"
                    href="#collapse6"
                  >
                    <span class="expand_icon dashicons-plus"></span>
                    <span> How to calculate broker commission?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse6" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    You will be charged a brokerage of up to ₹20 per order or
                    the SEBI prescribed limit whichever is lower for equity
                    delivery orders.
                  </p>
                  <p>
                    For equity intraday orders, you will be charged a brokerage
                    of ₹20 per order or 0.1% (whichever is lower) for both buy
                    and sell orders. For all other charges, you can refer to our
                    <a href="/brokerage-charges/">pricing page –</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#calculator_help_section"
                    href="#collapse7"
                  >
                    <span class="expand_icon dashicons-plus"></span>
                    <span>How to calculate delivery charges?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse7" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    You will be charged a brokerage of up to ₹20 per order or
                    the SEBI prescribed limit whichever is lower for equity
                    delivery orders.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#calculator_help_section"
                    href="#collapse8"
                  >
                    <span class="expand_icon dashicons-plus"></span>
                    <span>What are state stamp duty charges?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse8" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    For equity delivery, stamp duty charges are
                    <a href="/brokerage-charges/"
                      >0.015% or ₹1500 / crore on the buy side</a
                    >. For equity intraday, stamp duty charges are 0.003% or
                    ₹300 / crore on the buy side. For equity futures, stamp duty
                    charges are 0.002% or ₹200 /crore on the buy side and for
                    equity options stamp duty charges are 0.003% or ₹300 / crore
                    on the buy side. You can also check the stamp charges here
                    –<br />
                    <a href="/brokerage-charges/"
                      >https://upstox.com/brokerage-charges/</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#calculator_help_section"
                    href="#collapse9"
                  >
                    <span class="expand_icon dashicons-plus"></span>
                    <span>How to calculate breakeven?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse9" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    You can check the breakeven here –
                    <a href="/brokerage-charges/">Brokerage Calculator </a>
                    You just need to select the tax rates applicable for your
                    state, intraday or delivery, stock name, quantity, buy price
                    and sell price. Once you fill in the details, the breakeven
                    and the total taxes &amp; charges are calculated.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#calculator_help_section"
                    href="#collapse10"
                  >
                    <span class="expand_icon dashicons-plus"></span>
                    <span
                      >What are other charges in the brokerage calculator?</span
                    >
                  </span>
                </h3>
              </div>
              <div id="collapse10" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    Apart from brokerage, STT and state stamp duty, other
                    charges include
                    <a href="/brokerage-charges/"
                      >transaction charges, demat transaction charges, GST &amp;
                      SEBI charges.</a
                    >
                  </p>
                  <p><strong>Changes to be made:</strong></p>
                  <div
                    style="
                      display: block;
                      width: 100%;
                      overflow-x: auto;
                      -webkit-overflow-scrolling: touch;
                      border: none;
                    "
                  >
                    <table
                      style="
                        width: 100%;
                        border: 1px solid #dee2e6;
                        border-collapse: collapse;
                      "
                    >
                      <thead>
                        <tr style="background: #f5f5f5">
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          ></th>
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          >
                            Equity Delivery
                          </th>
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          >
                            Equity Intraday
                          </th>
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          >
                            Equity Futures
                          </th>
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          >
                            Equity Options
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            Transaction charges (From 1st April 2024 to 30th
                            September 2024)
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            NSE<br />
                            0.00322% per trade on buy &amp; sell.
                            <p></p>
                            <p>
                              BSE<br />
                              charges vary as per the scrip group
                            </p>
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            NSE<br />
                            0.00322% per trade on buy &amp; sell.
                            <p></p>
                            <p>
                              BSE<br />
                              charges vary as per the scrip group
                            </p>
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            NSE<br />
                            Exchange turnover charge: 0.00188%
                            <p></p>
                            <p>
                              BSE<br />
                              Nil
                            </p>
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            NSE<br />
                            0.0495% (on premium)
                            <p></p>
                            <p>
                              BSE<br />
                              0.0495% (on premium)
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            Transaction charges (From 1st October 2024)
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            NSE<br />
                            0.00297% per trade on buy &amp; sell.<br />
                            <br />
                            BSE<br />
                            charges vary as per the scrip group
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            NSE<br />
                            0.00297% per trade on buy &amp; sell.
                            <p></p>
                            <p>
                              BSE<br />
                              charges vary as per the scrip group
                            </p>
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            NSE<br />
                            Exchange turnover charge: 0.00173%
                            <p></p>
                            <p>
                              BSE<br />
                              Nil
                            </p>
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            NSE<br />
                            0.03503% (on premium)
                            <p></p>
                            <p>
                              BSE<br />
                              0.0325% (on premium)
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p><strong>Demat transaction charges</strong></p>
                  <div
                    style="
                      display: block;
                      width: 100%;
                      overflow-x: auto;
                      -webkit-overflow-scrolling: touch;
                      border: none;
                    "
                  >
                    <table
                      style="
                        width: 100%;
                        border: 1px solid #dee2e6;
                        border-collapse: collapse;
                      "
                    >
                      <thead>
                        <tr style="background: #f5f5f5">
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          >
                            Equity Delivery
                          </th>
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          >
                            Equity Intraday
                          </th>
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          >
                            Equity Futures
                          </th>
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          >
                            Equity Options
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            <strong>DP Charges: </strong>
                            <p></p>
                            <p>
                              <strong>For Male:</strong><br />
                              ₹3.5 (CDSL) + ₹16.5 (Upstox charges)
                            </p>
                            <p>
                              <strong>For Female</strong>: ₹3.25 (CDSL) + ₹16.75
                              (Upstox charges)
                            </p>
                            <p>Total: <strong>₹20.0 + GST</strong></p>
                            <p>
                              <strong
                                >Note: DP charges apply when selling stocks
                                under equity delivery.</strong
                              >
                            </p>
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            No charges
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            No charges
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            No charges
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse11">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>What are SEBI turnover fees?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse11" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    <strong
                      ><a href="/brokerage-charges/">SEBI charges</a></strong
                    >
                  </p>
                  <div
                    style="
                      display: block;
                      width: 100%;
                      overflow-x: auto;
                      -webkit-overflow-scrolling: touch;
                      border: none;
                    "
                  >
                    <table
                      style="
                        width: 100%;
                        border: 1px solid #dee2e6;
                        border-collapse: collapse;
                      "
                    >
                      <thead>
                        <tr style="background: #f5f5f5">
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          >
                            Equity Delivery
                          </th>
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          >
                            Equity Intraday
                          </th>
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          >
                            Equity Futures
                          </th>
                          <th
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              font-weight: 600;
                            "
                          >
                            Equity Options
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            ₹5/Cr
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            ₹5/Cr
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            ₹5/Cr
                          </td>
                          <td
                            style="
                              padding: 10px;
                              border: 1px solid #dee2e6;
                              background: #ffffff;
                            "
                          >
                            ₹5/Cr
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p>
                    For detailed brokerage &amp; other charges list across all
                    segments, refer to our charges list link here –
                    <a href="/brokerage-charges/"
                      >https://upstox.com/brokerage-charges/</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse12">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>What is CTT?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse12" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    Commodity Transaction Tax or CTT is just like Securities
                    Transaction Tax (STT) and is applied on all transactions
                    that are recognised as investments being made into domestic
                    commodity exchanges. This type of tax was implemented in
                    2016. All transactions that are carried out in foreign
                    commodity exchanges in foreign currencies are exempted from
                    CTT. It is also not applied to agricultural commodities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse13">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>How is commodity brokerage calculated?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse13" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    Commodity brokerage is calculated as per the commodity trade
                    value. The charge may be different for all brokers as each
                    sets their own charge. It can be either a flat rate or a
                    percentage. The CTT (commodities transaction tax) is
                    implemented on the seller as well as the buyer at 0.05% and
                    0.0001% respectively.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse14">
                    <span class="expand_icon dashicons-plus"></span>
                    <span
                      >Are stamp duty charges same for all Indian states?</span
                    >
                  </span>
                </h3>
              </div>
              <div id="collapse14" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    No, the stamp duty charges are different for all Indian
                    states. For example, the stamp duty rates for Andhra Pradesh
                    is 5%, Arunachal Pradesh is 6%, Assam is 8.25% while Bihar
                    has separate rates as per male and female.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="smooth-font">
          <div class="panel-group" id="accordion" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse15">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>Is brokerage the same for BSE &amp; NSE?</span>
                  </span>
                </h3>
              </div>
              <div id="collapse15" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    Yes, it is the same for both NSE &amp; BSE.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- text start similar-->
      <section class="similar_section">
        <div class="container">
          <div class="heading-wrap">
            <h2 class="fs-28 bold help_here">Similar Calculator</h2>
            <button
              class="similar-btn btn-all"
              v-if="!view"
              @click="view = !view"
            >
              View all
            </button>
            <button
              class="similar-btn btn-less"
              v-if="view"
              @click="view = !view"
            >
              View less
            </button>
          </div>
          <div class="smooth-wrap" :class="[view ? 'smooth-wrap2' : '']">
            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> Margin Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> Mutual Fund Returns Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> SIP Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> NPV Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> Future Value Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> SWP Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> ELSS Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> Option Value Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> NPS Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> PPF Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> Compound Annual Growth Rate Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> National Savings Certificate Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> Sukanya Samriddhi Yojana Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> Compound Interest Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> Atal Pension Yojana Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> Gratuity calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> Simple Interest Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> Fixed Deposit Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> GST Calculator</a>
              </h3>
            </div>

            <div class="smooth-font">
              <span class="img-wrap">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                  alt="Upstox Calculators"
                  class="simi-image"
                />
              </span>
              <h3>
                <a> HRA Calculator</a>
              </h3>
            </div>
          </div>
        </div>
      </section>

      <!-- Calculator Disclaimer Section -->
      <section class="container calculator-disclaimer brokerage-disclaimer">
        <p></p>
        <p>
          Disclaimer:<br />
          This calculator is meant to be used for indicative purposes only. It
          is designed to assist you in determining the appropriate amount of
          prospective investments. This calculator alone is not sufficient and
          shouldn’t be used for the development or implementation of any
          investment strategy. Upstox does not take the responsibility/liability
          nor does it undertake the authenticity of the figures calculated
          therein. Upstox makes no warranty about the accuracy of the
          calculators/reckoners. The examples do not claim to represent the
          performance of any security or investments. In view of the individual
          nature of tax consequences, each investor is advised to consult
          his/her own professional tax advisor before making any investment
          decisions on the basis of the results provided through the use of this
          calculator.
        </p>
        <p></p>
      </section>
    </div>
    <section
      class="summaryrow col-sm-hide col-xs-hide"
      style="display: none; position: fixed; bottom: 92px; top: initial"
    >
      <div class="">
        <div class="container">
          <div class="col-md-2">
            <p class="brcl-total">TOTAL</p>
          </div>
          <div class="col-md-2 col-sm-2 summaryvalue">
            <p class="summaryvalue-lbl">Brokerage</p>
            <p class="summaryvalue-amt">
              <span id="lblFooterBrokerage">₹&nbsp;0.00</span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 summaryvalue">
            <p class="summaryvalue-lbl">Brokerage + Taxes</p>
            <p class="summaryvalue-amt">
              <span id="lblFooterSTT">₹&nbsp;0.00</span>
            </p>
          </div>
          <div class="col-md-2 com-sm-2 summaryvalue">
            <p class="summaryvalue-lbl">Net PnL</p>
            <p class="summaryvalue-amt">
              <span id="lblFooterPnl">₹&nbsp;0.00</span>
            </p>
          </div>
          <div class="col-md-4 col-sm-4">
            <button class="samplenote-btn button" id="viewsamplecontract-btn">
              View Sample Contract Note
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- start Lookup section -->
    <div class="section-panel brokerage-calc-lookup">
      <section class="lookup-sec p-90 p-5">
        <div class="container">
          <div class="lookup-inner">
            <div class="lookup-inner_textbox">
              <h2>What is a brokerage calculator?</h2>
              <p>
                <span>
                  The charges and fees that amount to when trading in securities
                  is called brokerage. The calculator is an online investment
                  planning tool that is used to calculate the amount of
                  brokerage before the investment is made. This is crucial so
                  that we know what the actual returns will be once this amount
                  is subtracted from it. The Upstox calculator also calculates
                  and relays the amount to be paid separately for stamp duty
                  charges, transaction fees, SEBI turnover fees, GST and
                  securities transactions tax (STT).
                </span>
              </p>

              <h2>How does the Upstox brokerage calculator work?</h2>
              <p>
                <span>
                  The fees charged to facilitate trade is called brokerage. The
                  calculator helps us accurately decipher these fees, separating
                  individual heads like STT, GST, duty charge, transaction fees
                  and SEBI charges. The formula it uses is:
                </span>
              </p>

              <h2>
                Brokerage = Number of shares sold/bought x price per unit of
                stock x brokerage percentage
              </h2>
              <p>
                <span>
                  This formula is applied for both intraday and delivery trading
                  calculations.
                </span>
              </p>

              <h2>How to use the brokerage calculator?</h2>
              <p>
                <span>
                  The Upstox calculator provides a few parameters that need to
                  be filled before it can calculate the amounts individually
                  pointing out duty charges, transaction fees, STT, GST &amp;
                  SEBI charges. These parameters are:
                </span>
              </p>
              <ul>
                <li>Stock buy and sell price</li>
                <li>Number of shares</li>
                <li>Equity, commodity or currency</li>
                <li>Intraday or delivery</li>
              </ul>
              <p></p>
              <p>
                <span>
                  Once these values are input, the calculator makes the
                  calculations instantaneously and accurately.
                </span>
              </p>

              <h2>What are the types of brokerage calculators?</h2>
              <p>
                <span> There are 3 types of brokerage calculators: </span>
              </p>
              <ul>
                <li>
                  Equity: This calculator is used on all equity investments that
                  are traded through the NSE or BSE. Equity is company stock.
                </li>
                <li>
                  Commodity: Commodity shares are shares that are generally
                  listed MCX, NCDEX and more. These are essentially delivered
                  physically or settled in cash. This is when a person, purely
                  on instincts, bets on the movement of a market in a specified
                  time frame.
                </li>
                <li>
                  Currency: Currency is when investors can place investment into
                  foreign currency market. Forex is a good example of this.
                </li>
              </ul>
              <p></p>

              <h2>What are the advantages of a brokerage calculator?</h2>
              <p>
                <span>
                  The advantages of the Upstox brokerage calculator are:
                </span>
              </p>
              <ul>
                <li>Accurate and instant information.</li>
                <li>
                  Traders can use the tool to form comparative analysis between
                  different brokers.
                </li>
                <li>Helps in data analytics as well as transparency.</li>
                <li>
                  Helps to calculate all the charges separately, i.e., duty
                  <a href="/brokerage-charges/" target="_blanlk">charges</a>,
                  transaction fees, GST, STT and SEBI charges.
                </li>
                <li>It accounts for all trading costs.</li>
                <li>It is free and easy to use.</li>
              </ul>
              <p></p>

              <h2>Why is a brokerage calculator important for a trader?</h2>
              <p>
                <span>
                  A trader can select the correct broker firms as per his needs
                  and the calculator can help him make this partnership decision
                  wisely. The correct amount of deposits can be calculated and
                  the surprise element retired. It is crucial after all, to
                  maintain trader solvency through broker firms.
                </span>
              </p>
              <p>
                <span>
                  These online calculators can help the investors in making the
                  perfect execution of orders and achieve a staggering amount of
                  both daily and monthly trades. It is a prestigious online tool
                  that can help both the day trader as well as the investment
                  firm work together in harmony with complete transparency and
                  lack of doubt.
                </span>
              </p>

              <h2>What is intraday brokerage?</h2>
              <p>
                <span>
                  The service charge that is paid by the trader/investor to the
                  broker is called intraday brokerage. Each broker charges his
                  intraday brokerage along with STT (securities transaction tax)
                  and GST as this is imposed upon selling in intraday trading.
                  Apart from these charges, transaction fees, SEBI and NSE/BSE
                  regulatory fees and stamp duty charges are also paid.
                </span>
              </p>

              <h2>What is delivery trading and charges?</h2>
              <p>
                <span>
                  Delivery trading is a type of trading which deals in long term
                  trading, unlike intraday trading. It is when the investor buys
                  stock and it is delivered to his demat account. You can buy it
                  without all the money ready and cannot sell it without it
                  being held in your
                  <a
                    href="https://wa.me/+917092362098"
                    target="_blanlk"
                    >demat account</a
                  >. Your funds will stay frozen for that much amount of time.
                  Delivery charges are the charges levied to the broker to trade
                  in delivery stock. This is generally higher than intraday
                  charges.
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- end Lookup section -->
  </div>
</template>
<style scoped>
</style>
